import ClearIcon from "@material-ui/icons/esm/Clear";
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { vehicleInformation as vehicleInformationAtom } from 'api/vehicles/getVehicleInformation';
import { SecondaryButton } from 'components/Button';
import VehicleForm from 'components/VehicleForm/VehicleForm';
import { DEFAULT_LANGUAGE } from 'constants/language';
import { vehiclesToRegister as vehiclesToRegisterAtom, vehicleFormIdsToRegister as vehicleFormIdsToRegisterAtom, vehicleFormValid as vehicleFormValidAtom } from 'state/vehicles';
import jsonEqual from 'utils/general/jsonEquals';
export default function ChooseSingleVehicle({
  vehicleFormId
}) {
  const {
    t
  } = useTranslation();
  const vehicleInformation = useRecoilValue(vehicleInformationAtom(vehicleFormId));
  const [vehiclesToRegister, setVehiclesToRegister] = useRecoilState(vehiclesToRegisterAtom);
  const [vehicleFormIdsToRegister, setVehicleFormIdsToRegister] = useRecoilState(vehicleFormIdsToRegisterAtom);
  const vehicleFormValid = useRecoilValue(vehicleFormValidAtom(vehicleFormId));
  const form = useForm({
    defaultValues: {
      nationality: DEFAULT_LANGUAGE
    },
    mode: 'onChange'
  });
  const vehiclesToRegisterIndex = vehicleFormIdsToRegister.findIndex(v => v === vehicleFormId);
  useEffect(() => {
    if (vehiclesToRegisterIndex === -1) return;
    const vehicleToInsert = vehicleFormValid ? vehicleInformation : null;
    if (vehiclesToRegisterIndex >= vehiclesToRegister.length) setVehiclesToRegister(v => [...v, vehicleToInsert]);else if (!jsonEqual(vehiclesToRegister[vehiclesToRegisterIndex], vehicleToInsert)) setVehiclesToRegister(v => [...v.slice(0, vehiclesToRegisterIndex), vehicleToInsert, ...v.slice(vehiclesToRegisterIndex + 1)]);
  }, [vehicleInformation, vehicleFormId, vehicleFormIdsToRegister, vehiclesToRegister, setVehiclesToRegister, vehiclesToRegisterIndex, vehicleFormValid]);
  return /*#__PURE__*/React.createElement(FormProvider, form, /*#__PURE__*/React.createElement(VehicleForm, {
    vehicleFormId: vehicleFormId
  }), vehicleFormIdsToRegister.length > 1 && /*#__PURE__*/React.createElement(SecondaryButton, {
    startIcon: /*#__PURE__*/React.createElement(ClearIcon, null),
    outlined: false,
    onClick: () => {
      setVehicleFormIdsToRegister(v => v.filter(vid => vid !== vehicleFormId));
      setVehiclesToRegister(v => [...v.slice(0, vehiclesToRegisterIndex), ...v.slice(vehiclesToRegisterIndex + 1)]);
    }
  }, t('register_vehicle.remove_vehicle')));
}